export const styles = {
  lineClamp: (maxLines: number) => ({
    display: "-webkit-box",
    WebkitLineClamp: maxLines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  }),
};
